import {
  stringValidator,
} from '../../../../../OUI/Inputs';

export const tAccIdValidator = stringValidator;
